<script lang="ts" setup>

  const props = defineProps({
    node: { type: Object, required: true },
    open: { type: Boolean, required: true },
  });

  const openItemId = defineModel('openItemId', { type: Number });

  function show() {
    openItemId.value = props.node.id;
  }
</script>
<template>
  <button
    :class="{'item--open': open}"
    class="item"
    @click="show"
    @mouseenter="show"
  >
    <span class="item__title">
      <SfIconLightbulb aria-hidden="true" />
      {{ node.title }}
    </span>
  </button>
</template>
<style lang="scss" scoped>
  .item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);
    border: none;
    background: transparent;

    @media (max-width: 992px) {
      border-top-right-radius: var(--border-radius);
      border-top-left-radius: var(--border-radius);
      border-bottom-left-radius: 0;
      min-width: 140px;
      width: 100%;
    }

    @media (max-width: 576px) {
      font-size: 0.75rem;
      line-height: 1;
    }

    &__title {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.75rem 0 0.75rem 0.75rem;
      font-weight: var(--font-weight-semi);
      line-height: 1.5;

      @media (max-width: 992px) {
        flex-direction: column;
        justify-content: center;
        text-align: center;
        padding: 0.5rem;
      }
    }

    &--open {
      background: var(--color-white);
      color: var(--primary-color-active);
    }
  }
</style>